import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  
  connect() {
    this.element.addEventListener('change', this.change.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('change', this.change)
  }

  change(event) {
    this.updateUrl(event)
  }

  updateUrl(event) {
    console.log('updateUrl', event)
    const selectedOption = event.target.selectedOptions[0]
    const selectedClientId = selectedOption.value
    const preferredPoolerId = selectedOption.dataset.preferredPoolerId
    const currentUrl = window.location.pathname
    
    let url
    if (selectedClientId == 'all') {
      url = '/clients'
    } else if (selectedClientId != 'all' && currentUrl.match(/\/clients\/\d+/)) {
      // If URL contains /clients/<number>, replace the number and keep only first 5 path segments
      // This will typically mean the user stays on the same page/section but we remove any paths/id's that may be client specific.
      // For Example:
      // /clients/123/poolers/456/dashboard
      // /clients/123/poolers/456/movements
      // /clients/123/poolers/456/sites
      // /clients/123/poolers/456/tracking_sheets
      // /clients/123/poolers/456/invoices
      // /clients/123/poolers/456/exports
      // /clients/123/poolers/456/balance_logs
      // /clients/123/poolers/456/rate_cards
      // /clients/123/poolers/456/locations
      // /clients/123/poolers/456/reports
      // /clients/123/poolers/456/balances
      
      const baseUrl = currentUrl.split('/').slice(0, 6).join('/') // note that the path starts with a / also 
      url = baseUrl.replace(/\/clients\/\d+/, `/clients/${selectedClientId}`)
      // If we have a preferred pooler and the URL contains a pooler, update it
      if (preferredPoolerId && url.includes('/poolers/')) {
        url = url.replace(/\/poolers\/\d+/, `/poolers/${preferredPoolerId}`)
      }
    } else {
      // If URL doesn't match pattern, append the new client path with preferred pooler
      url = `/clients/${selectedClientId}/poolers/${preferredPoolerId}/dashboard`
    }

    Turbo.visit(url)
  }

}